"use client";

import { Children } from "react";
import Image from "next/image";
import Link from "next/link";

import { Skeleton, Text } from "@aprosoja/ui";
import { CardNews } from "@aprosoja/containers";
import NewsCreationInfo from "@/app/screens/complete-news/components/news-creation-info";

import useNewsList from "../../use-news-list";

const FeaturedNewsList = () => {
  const {
    firstTwoRecentFeaturedNews,
    remainingRecentFeaturedNews,
    featuredNewsIsLoading,
  } = useNewsList();

  return (
    <>
      {featuredNewsIsLoading ? (
        <Skeleton className="bg-neutral-300 w-full h-[1060px] mx-auto" />
      ) : (
        <Link
          href={`/noticias/${firstTwoRecentFeaturedNews[0].slug}`}
          className="flex flex-col gap-size-x16"
        >
          <div className="w-full">
            <div className="flex flex-col gap-size-x4">
              <div className="relative flex w-full h-[277px] tabletSmall:w-[650px] tabletLarge:w-[900px] tabletSmall:h-[327px] rounded-border-radius-small tabletMedium:h-[506px] mx-auto">
                <Image
                  className="object-cover rounded-border-radius-small"
                  src={firstTwoRecentFeaturedNews[0].imageUrl ?? ""}
                  alt="imagem-noticia"
                  fill
                />
              </div>
              <NewsCreationInfo
                authorName={firstTwoRecentFeaturedNews[0]?.author?.name ?? ""}
                categoryName={
                  firstTwoRecentFeaturedNews[0]?.category?.name ?? ""
                }
                createdAt={firstTwoRecentFeaturedNews[0]?.createdAt ?? ""}
              />
              <Text type="headingM">
                {firstTwoRecentFeaturedNews[0]?.title}
              </Text>
            </div>
          </div>
          <div className="grid grid-cols-1 tabletSmall:grid-cols-2 tabletLarge:grid-cols-3 desktopLarge:grid-cols-4 gap-size-x10">
            {remainingRecentFeaturedNews.length > 0
              ? Children.toArray(
                  remainingRecentFeaturedNews.map((news) => (
                    <CardNews
                      key={news.id}
                      orientation={"vertical"}
                      data={news}
                    />
                  ))
                )
              : [1, 2, 3, 4].map((index) => (
                  <CardNews key={index} orientation={"vertical"} />
                ))}
          </div>
        </Link>
      )}
    </>
  );
};

export default FeaturedNewsList;
